// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3UYlv","title":"Header_title__2PDYv","side":"Header_side__1FI-E"};